import { useMutation } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  mutation getUniquePrintRule($menuId: ID! $branchId: ID!) {
    getUniquePrintRule(menuId: $menuId, branchId: $branchId) {
      id
    }
  }
`);

export function useGetUniquePrintRule() {
  return useMutation(QUERY, {});
}
